import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import TenderTable from "./TenderTable";
import axios from "axios";
import VQTable from "./VQTable";
import SBOTable from "./CXO/SBOTable";
import TenderBidTable from "./CXO/TenderBidTable";
import TenderAwardTable from "./CXO/TenderAwardTable";
import ItemCount from "../../utils/ItemCount";

const CXODashboard = () => {
  const [tenders, setTenders] = useState();
  const [vq, setVq] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState(localStorage.getItem("activeTab") || "SIMULTANEOUS");
  const [isLoading, setIsLoading] = useState(true);
  const [isVQLoading, setIsVQLoading] = useState(true);
  const [pendingActions, setPendingActions] = useState(false);

  const [openingCount, setOpeningCount] = useState(0);
  const [awardedCount, setAwardedCount] = useState(0);
  const [bidCount, setBidCount] = useState(0);

  useEffect(() => {
    const getOpeningCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid-opening/item?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setOpeningCount(res.data);
      } catch (error) {
        console.log(error);
      }
    }
    getOpeningCount();
    const getAwardedCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setAwardedCount(res.data.length);
      } catch (error) {
        console.log(error);
      }
    }
    getAwardedCount();
    const getBidCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/awardee?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBidCount(res.data.length);
      } catch (error) {
        console.log(error);
      }
    }
    getBidCount();
    localStorage.removeItem("activeTab")
  }, [])

    useEffect(() => {
      if (activeTab === "SIMULTANEOUS") {
        const getTenders = async () => {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_BACKEND_URL}/bid-opening?username=${storedUser.username}`,
              { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
            );
            setTenders(res.data);
            setIsLoading(false);
          } catch (error) {
            console.log(error);
          }
        };
        getTenders();
      }
      if (activeTab === "BID") {
      localStorage.removeItem("tab")
        const getTenders = async () => {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_BACKEND_URL}/awardee?username=${storedUser.username}`,
              { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
            );
            setTenders(res.data);
            setIsLoading(false);
          } catch (error) {
            console.log(error);
          }
        };
        getTenders();
      }
      if (activeTab === "AWARDED") {
        const getTenders = async () => {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}&status=AWARDED`,
              { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
            );
            setTenders(res.data);
            setIsLoading(false);
          } catch (error) {
            console.log(error);
          }
        };
        getTenders();
      }
    }, [activeTab]);

  const getVendorTenders = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/org?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setVq(res.data);
      setIsVQLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (activeTab === "VQ") {
      getVendorTenders();
    }
  }, [activeTab]);

  useEffect(() => {
    if (localStorage.getItem("pending")) {
      setActiveTab("VQ");
      setPendingActions(true);
      localStorage.removeItem("pending");
    }
  }, []);
  return (
    <Box sx={{ textAlign: "center" }}>
      {/* {pendingActions ? (
        <>
          <Typography variant="h5" textAlign={"start"} fontWeight={"bold"}>
            My Pending Actions
          </Typography>
          <Box
            className="dashboard-container"
            sx={{ height: 400, width: "100%" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 2,
                borderBottom: "1px solid #D1D1D1",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >
                <Button
                  className={`dashboard-btns ${
                    activeTab === "GROUPED_QUERY" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("GROUPED_QUERY");
                    setIsLoading(true);
                    // setPendingActions(false);
                    // setVq();
                    // setIsVQLoading(true);
                  }}
                >
                  Query
                </Button>
                <Button
                  className={`dashboard-btns ${
                    activeTab === "VQ" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("VQ");
                    setIsLoading(true);
                  }}
                >
                  Vendor Qualification
                </Button>
                <Button
                  className={`dashboard-btns ${
                    activeTab === "BID" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("BID");
                    setIsLoading(true);
                  }}
                >
                  Bids Qualification
                </Button>
              </Box>
            </Box>
            {activeTab === "VQ" ? (
              <VQTable
                vendors={vq}
                activeTab={activeTab}
                isLoading={isVQLoading}
                getVendorTenders={getVendorTenders}
              />
            ) : null}
          </Box>
        </>
      ) : (
        <Box
          className="dashboard-container"
          sx={{ height: 400, width: "100%" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 2,
              borderBottom: "1px solid #D1D1D1",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Button
                className={`dashboard-btns ${
                  activeTab === "SIMULTANEOUS" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("SIMULTANEOUS");
                  setIsLoading(true);
                }}
              >
                Simultaneous Opening
              </Button>
              <Button
                className={`dashboard-btns ${
                  activeTab === "BID" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("BID");
                  setIsLoading(true);
                }}
              >
                Shortlisted Bid
              </Button>
              <Button
                className={`dashboard-btns ${
                  activeTab === "AWARDED" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("AWARDED");
                  setIsLoading(true);
                }}
              >
                Awarded
              </Button>
            </Box>
            <Box>
              <Button
                className="pending-btn"
                onClick={() => {
                  setPendingActions(true);
                  setActiveTab("GROUPED_QUERY");
                }}
              >
                My Pending actions
              </Button>
            </Box>
          </Box>
          <TenderTable
            tenders={tenders}
            activeTab={activeTab}
            isLoading={isLoading}
          />
        </Box>
      )} */}
      <Box
          className="dashboard-container"
          sx={{ height: 400, width: "100%" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 2,
              borderBottom: "1px solid #D1D1D1",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <Button
                className={`dashboard-btns ${
                  activeTab === "SIMULTANEOUS" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("SIMULTANEOUS");
                  setIsLoading(true);
                }}
              >
                Simultaneous Opening <ItemCount count={openingCount} />
              </Button>
              <Button
                className={`dashboard-btns ${
                  activeTab === "BID" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("BID");
                  setIsLoading(true);
                  localStorage.setItem("activeTab", "BID")
                }}
              >
                Shortlisted Bid <ItemCount count={bidCount} />
              </Button>
              <Button
                className={`dashboard-btns ${
                  activeTab === "AWARDED" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("AWARDED");
                  setIsLoading(true);
                }}
              >
                Awarded <ItemCount count={awardedCount} />
              </Button>
            </Box>
          </Box>
          {activeTab === "SIMULTANEOUS" ?
          <SBOTable
            tenders={tenders}
            activeTab={activeTab}
            isLoading={isLoading}
          /> : activeTab === "BID" ? 
          <TenderBidTable tenders={tenders} activeTab={activeTab} isLoading={isLoading} />
          :
          <TenderAwardTable tenders={tenders} activeTab={activeTab} isLoading={isLoading}/>}
        </Box>
    </Box>
  );
};

export default CXODashboard;